import { render, staticRenderFns } from "./Initiatives.vue?vue&type=template&id=9f88e5fa&"
import script from "./Initiatives.vue?vue&type=script&lang=js&"
export * from "./Initiatives.vue?vue&type=script&lang=js&"
import style0 from "./Initiatives.vue?vue&type=style&index=0&id=9f88e5fa&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports